import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getSlidersPanel = async (searchTerm,page,perPage) => {
    let queryParams = [];
    if (searchTerm) {
      queryParams.push(`descripcion=${encodeURIComponent(searchTerm|| '')}`);
    }
    if (page) {
      queryParams.push(`page=${encodeURIComponent(page)}`);
    }
    if (perPage) {
      queryParams.push(`perPage=${encodeURIComponent(perPage)}`);
    }
    const queryString = queryParams.length > 0 ? `?}&${queryParams.join('&')}` : '';    
    return await getData("/sliders/sliders_panel", queryString);
  };

export const getSliderById = async (id) => {
    const res = await getData(`/sliders/${id}`)
    return res
}

export const postSlider = async (body) => {
    const res = await postData('/sliders', body)
    return res
}

export const patchSlider = async (id, body) => {
    const res = await patchData(`/sliders/${id}`, body)
    return res
}

export const deleteSlider = async (id) => {
    const res = await deleteData(`/sliders/${id}`)
    return res
}